export default __webpack_public_path__ + "static/media/check.73d8825f.svg";